import sparse from "./sparse";
import { Selection } from "./index";
export default function () {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/exit.js
// module id = 477
// module chunks = 0